import React from "react";
import "./Personal_training.css"
import { Container } from "react-bootstrap";
import Component_1 from "../tabs_common_components/component_1/Component_1";
import Component_2 from "../tabs_common_components/component_2/Component_2";
import Component_3 from "../tabs_common_components/component_3/Component_3";
import Component_5 from "../tabs_common_components/component_5/Component_5";

const Personal_training = () => {
  const focusData = [
    {
      id: 1,
      icon: "/assets/images/sports-program/component-3/strength.png",
      title: "Strength",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 2,
      icon: "/assets/images/sports-program/component-3/endurance.png",
      title: "Endurance",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 3,
      icon: "/assets/images/sports-program/component-3/speed-agility.png",
      title: "Speed & Agility",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 4,
      icon: "/assets/images/sports-program/component-3/flexibility.png",
      title: "Flexibility",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
    {
      id: 5,
      icon: "/assets/images/sports-program/component-3/body-toning.png",
      title: "Body & Mind Coordination",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus.",
    },
  ];
  return (
    <section className="personal_training_section">
      <Container>
        <Component_1
          topDescn={
            "Our Personal Training Program is designed to give you one-on-one attention with a certified trainer who focuses completely on your fitness goals. Whether you want to lose weight, build muscle, improve endurance, or stay fit, we create a customized plan just for you."
          }
          title={"What a Personal Trainer Does"}
          features={[
            {
              label: "Creates a Personalized Plan:",
              value:
                "Every journey starts with an assessment of your fitness level, goals, and health history, followed by a customized training plan built just for you.",
            },
            {
              label: "Provides Expert Instruction:",
              value:
                "Every journey starts with an assessment of your fitness level, goals, and health history, followed by a customized training plan built just for you.",
            },
            {
              label: "Motivates & Holds You Accountable:",
              value:
                "Every journey starts with an assessment of your fitness level, goals, and health history, followed by a customized training plan built just for you.",
            },
            {
              label: "Offers Nutrition Guidance:",
              value:
                "Basic nutrition and meal tips are provided to complement your workouts and support your overall health.",
            },
            {
              label: "Monitors Progress:",
              value:
                "Trainers regularly track your improvement and adjust your plan to keep you progressing safely and steadily.",
            },
          ]}
          imgSrc="./assets/images/sports-program/component-1/personal_training.png"
        />
        <div className="our_goal">
          <div className="head">Our Goal</div>
          <p className="text">
            To deliver personalized fitness solutions that help you achieve
            faster, safe, and long-lasting results.
          </p>
        </div>
        <Component_5
          title={"Benefits of Personal Training"}
          features={[
            "Faster and more effective results",
            "Personalized workout plan",
            "Proper technique and form guidance",
            "High motivation and accountability",
            "Reduced risk of injury",
            "Focused goal-based training",
          ]}
        />

        <Component_2
          title={"Weekly Workout Plan"}
          imgSrc="./assets/images/sports-program/component-2/friend.png"
          features={[
            {
              label: "Two Strength Sessions: ",
              value: "Focused on back, biceps, shoulders, chest, and legs.",
              imgSrc: "./assets/images/sports-program/component-2/friend.png",
            },
            {
              label: "One Yoga Session:  ",
              value:
                "Conducted by a certified yoga trainer for flexibility and recovery.",
              imgSrc: "./assets/images/sports-program/component-2/yoga.png",
            },
            {
              label: "Additional Sessions: ",
              value:
                "Running, HIIT, hill runs, ladder & hurdle drills, jumping, and agility exercises.",
              imgSrc: "./assets/images/sports-program/component-2/calender.png",
            },
          ]}
        />

        <Component_5
          title={"What we offer"}
          features={[
            "One-on-one training sessions",
            "Customized workout plans",
            "Strength and conditioning training",
            "Weight loss & fat loss programs",
            "Muscle building programs",
            "Functional training",
            "Flexibility & mobility exercises",
            "Posture correction & injury prevention",
          ]}
        />

        <Component_3 focusData={focusData} />
      </Container>
    </section>
  );
};

export default Personal_training;
